import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import plant from "../../../assets/icons/climate.png";
import ai from "../../../assets/icons/ai.png";
import city from "../../../assets/icons/city.png";
import ecosystem from "../../../assets/icons/ecosystem.png";
import { Card } from "@mui/material";

const objectList = [
  {
    icon: plant,
    title: "Climate Resilience",
    subtitle:
      "AIR Fund invests in projects that enhance climate resilience through sustainable agriculture, renewable energy, and water conservation. Initiatives include drought-resistant crops, small-scale solar installations, and efficient irrigation systems to protect vulnerable communities and secure food sources.",
  },
  {
    icon: ai,
    title: "Artificial Intelligence & Technology",
    subtitle:
      "AIR Fund supports AI-driven solutions in healthcare, education, and governance to bridge data gaps and expand access. Investments focus on AI-powered diagnostics, digital literacy programs, and agricultural analytics, ensuring ethical and community-driven technological growth.",
  },
  {
    icon: city,
    title: "Expanding Economic Opportunities",
    subtitle:
      "AIR Fund prioritizes expansion of economic opportunities by leveraging the growth potential of Africa’s secondary cities by empowering young people to drive transformative change and accelerate regional development, productivity and creation of resilient economic hubs, reducing pressure on capital cities. ",
  },
  {
    icon: ecosystem,
    title: "Innovation Ecosystem Networks",
    subtitle:
      "AIR Fund nurtures African-led innovation by strengthening networks, providing mentorship, and offering capital to entrepreneurs. Our goal is to build a self-sustaining pipeline of innovators transforming ideas into scalable solutions.",
  },
];

const Focus = () => {
  return (
    <Box margin={{ xs: "35% 0%", sm: "10% 0% 10% 0%" }} data-aos={"fade-up"}>
      <Typography
        variant="h3"
        fontWeight={900}
        textAlign={"left"}
        paddingBottom={{ xs: "4%", sm: "2%" }}
        color={"#39484E"}
      >
        Core Focus Areas
      </Typography>
      <Grid container spacing={1}>
        {objectList.map((list, index) => {
          const { title, icon, subtitle } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                margin={{ xs: "5% 0%", sm: "0%" }}
              >
                <Box
                  key={index}
                  height={"100%"}
                  padding={{ xs: "4% 4%", sm: "8% 8% 4% 8%" }}
                  margin={{ xs: "2% 0%", sm: "2% 0%" }}
                  display={"flex"}
                  component={Card}
                  flexDirection={"column"}
                  borderRadius={"20px"}
                  width={{ xs: "100%", sm: "100%" }}
                  // sx={{ bgcolor: "#EBF4F6" }}
                >
                  <Box marginLeft={"2%"}>
                    {" "}
                    <Box
                      component="img"
                      height={{ xs: "64px", sm: "64px" }}
                      sx={{
                        objectFit: "cover",
                        overflow: "hidden",
                        width: "100%",
                      }}
                      src={icon}
                      alt={"icons"}
                    />
                  </Box>
                  <Typography
                    variant={"h5"}
                    fontWeight={700}
                    paddingTop={"6%"}
                    color={"#39484E"}
                  >
                    {title}
                  </Typography>
                  <Typography
                    variant={"body1"}
                    paddingTop={"2%"}
                    color={"#000"}
                  >
                    {subtitle}
                  </Typography>
                </Box>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Focus;
